import { useTranslation } from "react-i18next";
import { DateRange } from "@/domains/common";
// components
import { Button } from "antd";

export const DateRangeButtonGroup = ({
  dateRange,
  onChange,
}: {
  dateRange: DateRange;
  onChange: (v: any) => void;
}) => {
  const { t } = useTranslation();

  const dateRangeButtons = [
    {
      label: t("systems.Date.dateRanges.day0"),
      value: DateRange.day0,
    },
    {
      label: t("systems.Date.dateRanges.day1"),
      value: DateRange.day1,
    },
    {
      label: t("systems.Date.dateRanges.week0"),
      value: DateRange.week0,
    },
    {
      label: t("systems.Date.dateRanges.week1"),
      value: DateRange.week1,
    },
    {
      label: t("systems.Date.dateRanges.month0"),
      value: DateRange.month0,
    },
    {
      label: t("systems.Date.dateRanges.month1"),
      value: DateRange.month1,
    },
  ];

  return (
    <div className="mt:24 flex jc:center ai:center gap:16">
      {dateRangeButtons.map(({ label, value }) => (
        <Button
          type={dateRange === value ? "primary" : "default"}
          onClick={() => onChange(value)}
          key={value}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
